var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-active-element',{staticClass:"ui-icon-button",attrs:{"disabled":_vm.disabled,"title":_vm.text},on:{"click":_vm.onClick}},[_c('app-icon',{attrs:{"height":_vm.height,"name":_vm.name,"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }